import {
  responseDataFormat,
  handleCatchErrors,
  responseDataFormatRedux,
} from "../../middlewares/resolveRequests";
import * as actionTypes from "./actionTypes";
import {
  addAgenda,
  addLink,
  deleteAgenda,
  getAgenda,
  getAllAgenda,
  getAllLinks,
  getLink,
  updateAgenda,
  updateLink,
} from "../../services/agendaAndLinks";

export const getAllLinksAPI = async (data, token) => {
  let response;
  try {
    response = await getAllLinks(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_ALL_LINKS);
  }
};
export const getAllAgendaAPI = async (data, pageSize, pageNumber, token) => {
  let response;
  try {
    response = await getAllAgenda(data, pageSize, pageNumber, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_ALL_AGENDA);
  }
};
export const clearAllLinksAPI = () => {
  return responseDataFormatRedux({ data: null }, actionTypes.GET_ALL_LINKS);
};

export const addLinkAPI = async (data, token) => {
  let response;

  try {
    response = await addLink(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.ADD_LINK);
  }
};
export const addAgendaAPI = async (data, token) => {
  let response;

  try {
    response = await addAgenda(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.ADD_AGENDA);
  }
};

export const updateLinkAPI = async (data, token) => {
  let response;

  try {
    response = await updateLink(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.UPDATE_LINK);
  }
};
export const updateAgendaAPI = async (data, token) => {
  let response;

  try {
    response = await updateAgenda(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.UPDATE_AGENDA);
  }
};

export const getLinkAPI = async (id, token) => {
  let response;

  try {
    response = await getLink(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_LINK);
  }
};
export const getAgendaAPI = async (id, token) => {
  let response;

  try {
    response = await getAgenda(id, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.GET_AGENDA);
  }
};
export const deleteLinkAPI = async (data, token) => {
  let response;

  try {
    response = await deleteLinkAPI(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.DELETE_LINK);
  }
};
export const deleteAgendaAPI = async (data, token) => {
  let response;

  try {
    response = await deleteAgenda(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormatRedux(response, actionTypes.DELETE_AGENDA);
  }
};
